define('ProductViews.Option.View.GiftWrap', [
    'SC.Configuration',
    'underscore'
], function ProductViewsOptionViewGiftWrap(
    Configuration,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layoutComponent = container.getComponent('Layout');

            layoutComponent.addToViewContextDefinition('ProductViews.Option.View', 'showOption', 'boolean', function showOption() {
                var pdpComponent = container.getComponent('PDP');
                var selectedChilds = pdpComponent.getSelectedMatrixChilds() || [];
                var itemInfo = pdpComponent.getItemInfo();

                if (!itemInfo) {
                    return false;
                }
                return selectedChilds.length ? true : itemInfo.item[itemInfo.item.keyMapping_isGiftwrappable] || false;
            });

            layoutComponent.addToViewContextDefinition('ProductViews.Option.View', 'giftWrapFee', 'number', function giftWrapFee() {
                return _.formatCurrency(Configuration.customizations.giftWrap.giftWrapFee);
            });

            layoutComponent.addToViewContextDefinition('ProductViews.Option.View', 'giftWrapImg', 'string', function giftWrapImg() {
                return Configuration.customizations.giftWrap.giftWrapImg;
            });
        }
    };
});

